import {
  FETCH_SECTORS_REQUEST,
  FETCH_SECTORS_SUCCESS,
  FETCH_SECTORS_FAILURE,
  FETCH_SECTOR_REQUEST,
  FETCH_SECTOR_SUCCESS,
  FETCH_SECTOR_FAILURE,
  UPDATE_SECTORS_REQUEST,
  UPDATE_SECTORS_FAILURE,
  UPDATE_SECTORS_SUCCESS,
  DELETE_SECTORS_REQUEST,
  DELETE_SECTORS_FAILURE,
  DELETE_SECTORS_SUCCESS,
  FETCH_SECTORS_RELEASE_REQUEST,
  FETCH_SECTORS_RELEASE_SUCCESS,
  FETCH_SECTORS_RELEASE_FAILURE,
  CLEAR_SECTOR_ERRORS,    // Nouvelles imports
  CLEAR_SECTOR_SUCCESS,
} from './actionTypes';

const initialState = {
  sectors: [],
  sectorsRelease: [], // Ajouté car utilisé dans le reducer
  sector: null,
  loadingSector: false,
  errorSector: null,
  sectorAdded: null
};

const Sectors = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SECTORS_REQUEST:
      return {
        ...state,
        loadingSector: true,
        errorSector: null,
        sectorAdded: false
      };
    case FETCH_SECTORS_SUCCESS:
      return {
        ...state,
        loadingSector: false,
        sectors: action.payload.data,
      };
    case FETCH_SECTORS_FAILURE:
      return {
        ...state,
        loadingSector: false,
        errorSector: action.payload,
      };
    case FETCH_SECTORS_RELEASE_REQUEST:
      return {
        ...state,
        loadingSector: true,
        errorSector: null,
        sectorAdded: false
      };
    case FETCH_SECTORS_RELEASE_SUCCESS:
      return {
        ...state,
        loadingSector: false,
        sectorsRelease: action.payload.data,
      };
    case FETCH_SECTORS_RELEASE_FAILURE:
      return {
        ...state,
        loadingSector: false,
        errorSector: action.payload,
      };
    case FETCH_SECTOR_REQUEST:
      return {
        ...state,
        loadingSector: true,
        errorSector: null,
        sectorAdded: false
      };
    case FETCH_SECTOR_SUCCESS:
      return {
        ...state,
        loadingSector: false,
        sector: action.payload.data,
      };
    case FETCH_SECTOR_FAILURE:
      return {
        ...state,
        loadingSector: false,
        errorSector: action.payload,
      };
    case UPDATE_SECTORS_REQUEST:
      return {
        ...state,
        loadingSector: true,
        errorSector: null,
        sectorAdded: false
      };
    case UPDATE_SECTORS_SUCCESS:
      return {
        ...state,
        loadingSector: false,
        sector: null,
        sectorAdded: true
      };
    case UPDATE_SECTORS_FAILURE:
      return {
        ...state,
        loadingSector: false,
        errorSector: action.payload,
      };
    case DELETE_SECTORS_REQUEST:
      return {
        ...state,
        loadingSector: true,
        errorSector: null,
        sectorAdded: false
      };
    case DELETE_SECTORS_SUCCESS:
      return {
        ...state,
        sectorAdded: true,
        loadingSector: false,
        sectors: state.sectors.filter(sector => sector.id !== action.payload),
      };
    case DELETE_SECTORS_FAILURE:
      return {
        ...state,
        loadingSector: false,
        errorSector: action.payload,
      };
    case CLEAR_SECTOR_ERRORS:
      return {
        ...state,
        errorSector: null,
      };
    case CLEAR_SECTOR_SUCCESS:
      return {
        ...state,
        sectorAdded: null,
      };
      
    default:
      return state;
  }
};

export default Sectors;